module.exports = __webpack_public_path__ + "static/media/icons-google-play-480.c30cd744.png";